import React, { Component } from 'react'
import EmptyMessageCard from 'components/Cards/EmptyMessageCard'
import { Table, TableHeader, TableRow } from 'features/Table'
import { Link } from 'react-router'
import SelectPretty from 'components/Input/SelectPretty'
import { Field } from 'redux-form'
import cn from 'classnames'
import sMarg from 'styles/modules/margins.scss'
import sLay from 'styles/modules/layout.scss'
import Button from 'components/Button'

export default class CasesList extends Component {
  componentWillMount() {
    const { getCases } = this.props
    getCases()
  }
  render() {
    const { cases, getCasesLoading, formData, showCasesViewModal } = this.props
    const casesFiltered = formData.filter
      ? cases.filter(item => item.recordType === formData.filter)
      : cases

    const tableHeader = (
      <TableHeader>
        <div>Case #</div>
        <div className={sLay['hide-xs']}>Billing Account</div>
        <div>Type</div>
        <div>Status</div>
        <div style={{ maxWidth: '76px' }} />
      </TableHeader>
    )

    const options = [
      {
        value: '',
        name: 'All',
      },
      {
        value: 'Billing Dispute',
        name: 'Billing Dispute',
      },
      {
        value: 'Billing Enquiry',
        name: 'Billing Enquiry',
      },
      {
        value: 'Trouble Ticket',
        name: 'Trouble Ticket',
      },
    ]

    return (
      <div>
        <div className={cn(sMarg.mb30, sLay['layout-row'], sLay['layout-align-end'])}>
          <Field
            label="Type"
            component={SelectPretty}
            options={options}
            name="filter"
            display="box"
          />
        </div>
        {!casesFiltered || casesFiltered.length === 0 ? (
          <EmptyMessageCard
            loading={getCasesLoading}
            title="You have no Support Cases"
            subtitle={
              formData.filter
                ? 'Try clearing the search filters.'
                : "They'll appear here when you contact support or request a new service."
            }
          />
        ) : (
          <form>
            <Table header={tableHeader}>
              {casesFiltered.map(item => (
                <TableRow key={item.id}>
                  <div>{item.caseId}</div>
                  <div className={sLay['hide-xs']}>
                    <Link to={`/dashboard/billing/accounts/${item.ban}`}>{item.ban}</Link>
                  </div>
                  <div>{item.recordType}</div>
                  <div>{item.status}</div>
                  <div style={{ maxWidth: '76px' }}>
                    <Button
                      color="tertiary"
                      size="xs"
                      ghost
                      onClick={() => showCasesViewModal({ caseItem: item })}
                    >
                      View
                    </Button>
                  </div>
                </TableRow>
              ))}
            </Table>
          </form>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesList/CasesList.jsx